import React from 'react'
import styled from 'styled-components'
import Text, { useTranslations } from '../../utils/Text'

const Container = styled.div`
  margin-bottom: ${props =>
    props.marginBText ? props.marginBText : 10}px;
`

const TextContainer = styled.div`
  max-width: 683px;
  margin: 0 auto 10px;
  text-align: center;
  span {
    color: ${props =>
      props.textColor ? props.textColor : '#414141'};
    font-size: ${props => (props.textSize ? props.textSize : 16)}px;
    line-height: 1.44;
    font-family: ${props =>
      props.fontFamily ? props.fontFamily : 'Raleway'};
  }
`

const Code = styled.p`
  span {
    font-family: ${props =>
      props.fontFamily ? props.fontFamily : 'Raleway'};
    font-size: ${props => (props.textSize ? props.textSize : 30)}px;
    color: ${props => props.codeColor};
    margin-bottom: ${props => props.marginBCode}px;
    text-decoration: underline;
  }
`

export default function Coupon({ coupon, ...props }) {
  const {
    text,
    textSize,
    textColor,
    marginBText,
    fontFamily,
    codeSize,
    codeColor,
    marginBCode,
    code,
    nocode,
    optional,
  } = props
  const textToShow = useTranslations(text, { optional })
  const codeToShow = useTranslations(code, { optional })
  if (optional && textToShow === null) return null

  const getCoupon = () => {
    if (codeToShow !== 'not-unique') {
      // unique code from json
      return <span>{codeToShow}</span>
    }
    // not unique code from api
    if (!coupon) return <Text id={nocode} className="nocode" />
    return <span>{coupon}</span>
  }

  return (
    <Container marginBText={marginBText}>
      <TextContainer
        textSize={textSize}
        textColor={textColor}
        fontFamily={fontFamily}
      >
        <Text id={text} />
      </TextContainer>
      <Code
        codeSize={codeSize}
        codeColor={codeColor}
        marginBCode={marginBCode}
        fontFamily={fontFamily}
      >
        {getCoupon()}
      </Code>
    </Container>
  )
}
